import {useRef, useState} from 'react';
import DropCard from './DropCard';
import toast from 'react-hot-toast';
import CandidateDeclineRejectionModal from './CandidateDeclineModal';
import {useCanidateJobUpdateMutation} from '../../api/candidate';

import RejectedIcon from './../../assets/icons/rejected.svg';
import InboxIcon from './../../assets/icons/inbox.svg';
import InboxIconS from './../../assets/icons/inbox_s.svg';
import ReviewIcon from './../../assets/icons/inreview.svg';
import ReviewIconS from './../../assets/icons/inreview_s.svg';
import InterviewIcon from './../../assets/icons/interview.svg';
import InterviewIconS from './../../assets/icons/interview_s.svg';
import HiredIcon from './../../assets/icons/hired.svg';
import HiredIconS from './../../assets/icons/hired_s.svg';
import OfferedIcon from './../../assets/icons/offered.svg';
import OfferedIconS from './../../assets/icons/offered_s.svg';
import RejectedIconS from './../../assets/icons/rejected_s.svg';

export const jobStages = [
  {
    id: 1,
    title: 'Inbox',
    value: 'inbox',
    icon: <InboxIcon />,
    iconSmall: <InboxIconS />,
  },
  {
    id: 2,
    title: 'In Review',
    value: 'review',
    icon: <ReviewIcon />,
    iconSmall: <ReviewIconS />,
  },
  {
    id: 3,
    title: 'Interview',
    value: 'interview',
    icon: <InterviewIcon />,
    iconSmall: <InterviewIconS />,
  },
  {
    id: 4,
    title: 'Offered',
    value: 'offered',
    icon: <HiredIcon />,
    iconSmall: <HiredIconS />,
  },
  {
    id: 5,
    title: 'Hired',
    value: 'hired',
    icon: <OfferedIcon />,
    iconSmall: <OfferedIconS />,
  },
  {
    id: 6,
    title: 'Rejected',
    value: 'rejected',
    icon: <RejectedIcon />,
    iconSmall: <RejectedIconS />,
    dropable: false,
  },
  {
    id: 'declined',
    title: 'Declined',
    value: 'declined',
    icon: <RejectedIcon />,
    iconSmall: <RejectedIconS />,
    dropable: false,
  },
];

const Board = ({
  jobDetails,
  candidateDetails,
  setCandidateDetails,
  reasonModal,
  setReasonModal,
  setAddCandidateModal,
}) => {
  const [score, setScore] = useState('');
  const [stage, setStage] = useState();

  const {mutate: candidateJobUpdateMutation, isLoading: isJobUpdateLoading} =
    useCanidateJobUpdateMutation();

  const candidateJobUpdatemutationOptions = {
    onSuccess: () => {
      setAddCandidateModal(false);
      setReasonModal(false);
      toast.success('Candidate Stage updated');
    },
    onError: (data) => toast.error(data.response.data.message),
  };

  const dragItem = useRef();
  let dragOverItem = useRef();

  const dragStart = (position, id) => {
    dragItem.id = position;
    dragItem.oldPos = id;
  };

  const dragEnter = (position) => {
    dragOverItem = position;
  };

  const handleCandidates = () => {
    let newArr = [];
    if (candidateDetails[dragOverItem]?.length > 0) {
      newArr = [
        ...candidateDetails[dragOverItem],
        candidateDetails[dragItem.oldPos]?.find((i) => i._id === dragItem.id),
      ];
    } else {
      newArr = [
        candidateDetails[dragItem.oldPos]?.find((i) => i._id === dragItem.id),
      ];
    }

    setCandidateDetails((prev) => {
      return {
        ...prev,
        [dragOverItem]: [...newArr],
        [dragItem.oldPos]: [
          ...(candidateDetails[dragItem.oldPos] || []).filter(
            (i) => i._id !== dragItem.id,
          ),
        ],
      };
    });
  };

  const handleCancel = () => {
    setReasonModal(false);
  };

  const handleConfirm = () => {
    if (score?.trim()) {
      const payload = {
        jobId: dragItem.id,
        payload: {stage, rejectedReason: score},
      };
      candidateJobUpdateMutation(payload, candidateJobUpdatemutationOptions);
    } else {
      toast.error('Enter rejection reason!');
    }
  };

  const drop = () => {
    if (dragItem.oldPos !== dragOverItem && dragOverItem !== 'declined') {
      setScore(dragItem.score);
      handleCandidates();
      setStage(dragOverItem);

      if (dragOverItem === 6) {
        setReasonModal(true);
      } else {
        const payload = {jobId: dragItem.id, payload: {stage: dragOverItem}};
        candidateJobUpdateMutation(payload, candidateJobUpdatemutationOptions);
      }
    }
  };

  return (
    <div>
      <div>
        <div className="flex pb-3 pr-3 gap-3 overflow-x-auto w-full">
          {jobStages.map((item) => (
            <DropCard
              item={item}
              key={item.title}
              id={item.id}
              value={
                item.value === 'interview'
                  ? jobDetails?.['inProgress']
                  : jobDetails?.[item.value]
              }
              drop={drop}
              candidates={candidateDetails?.[item.id]}
              dragStart={dragStart}
              dragEnter={dragEnter}
              dropable={item?.dropable}
            />
          ))}
        </div>
      </div>

      {/* Rejection Modal */}
      {reasonModal && (
        <CandidateDeclineRejectionModal
          isOpen={reasonModal}
          onClose={handleCancel}
          value={score}
          text="rejection reason"
          type="text"
          setValue={setScore}
          loading={isJobUpdateLoading}
          confirm={handleConfirm}
        />
      )}
    </div>
  );
};

export default Board;
